/* istanbul ignore file */
import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../../reducers';

// nullState used for route selectors which do not need state
// Used to follow selector pattern for all route selectors
export const nullState = createSelector(
  () => null,
  (value) => value,
);

export const selectRouterReducer = createSelector(
  fromFeature.getRouterState,
  (routerReducerState) => routerReducerState,
);
export const selectRouterState = createSelector(
  selectRouterReducer,
  (routerReducerState) => routerReducerState?.state,
);

// test monkey
export const getTestMonkeyNextPage = (): string => 'secure/inheritance/decedent-info';
export const selectTestMonkeyNextPage = createSelector(nullState, () => getTestMonkeyNextPage());
